// 询价清单表单

import { Pagination, Row, Tabs, Tooltip } from 'antd'
import { useState, forwardRef, useImperativeHandle } from 'react'
import TabItem from './tabItem'
import { QuotationItemDTO } from '@/api/inquiry'
import { InquiryQuotationListItem } from '../../reducer'

interface XJFormProps {
  item: InquiryQuotationListItem
}

export interface XJFormRef {
  switchToTab: (tabIndex: number) => void
}

const XJForm = forwardRef<XJFormRef, XJFormProps>((props, ref) => {
  const { item } = props
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0)

  // 暴露给父组件的方法
  useImperativeHandle(ref, () => ({
    switchToTab: (tabIndex: number) => {
      if (tabIndex >= 0 && tabIndex < (item?.items?.length || 0)) {
        setActiveTabIndex(tabIndex)
      }
    },
  }))

  const makeLabel = (it: QuotationItemDTO, idx: number) => {
    const text = it.clientMaterialName || `明细${idx + 1}`
    return (
      <Tooltip title={text} getTooltipContainer={() => document.body}>
        <div
          style={{
            maxWidth: '120px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {text}
        </div>
      </Tooltip>
    )
  }

  const makeKey = (it: QuotationItemDTO, idx: number) => it?.id || `${idx}`

  // Tab切换处理
  const handleTabChange = (activeKey: string) => {
    const index =
      item?.items?.findIndex(
        (_: any, idx: number) => makeKey(item.items[idx], idx) === activeKey,
      ) ?? 0
    if (index !== -1) {
      setActiveTabIndex(index)
    }
  }

  // 分页切换处理
  const handlePageChange = (page: number) => {
    const targetIndex = page - 1 // 分页从1开始，数组索引从0开始
    setActiveTabIndex(targetIndex)
  }

  return (
    <div>
      <Tabs
        activeKey={makeKey(item?.items?.[activeTabIndex], activeTabIndex)}
        onChange={handleTabChange}
        items={
          item?.items?.map((it: QuotationItemDTO, idx: number) => ({
            label: makeLabel(it, idx),
            key: makeKey(it, idx),
            children: <TabItem item={it} bjdItem={item} index={idx} />,
            forceRender: true,
          })) || []
        }
        destroyInactiveTabPane={false}
      />
      <Row justify={'end'} className="mt-[20px]">
        <Pagination
          showQuickJumper
          pageSize={1}
          total={item?.items?.length}
          current={activeTabIndex + 1} // 分页从1开始，数组索引从0开始
          onChange={handlePageChange}
        />
      </Row>
    </div>
  )
})

XJForm.displayName = 'XJForm'

export default XJForm
// 询价清单表单

import { Pagination, Row, Tabs, Tooltip } from 'antd'
import { useState, forwardRef, useImperativeHandle } from 'react'
import TabItem from './tabItem'
import { QuotationItemDTO } from '@/api/inquiry'
import { InquiryQuotationListItem } from '../../reducer'

interface XJFormProps {
  item: InquiryQuotationListItem
}

export interface XJFormRef {
  switchToTab: (tabIndex: number) => void
}

const XJForm = forwardRef<XJFormRef, XJFormProps>((props, ref) => {
  const { item } = props
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0)

  // 暴露给父组件的方法
  useImperativeHandle(ref, () => ({
    switchToTab: (tabIndex: number) => {
      if (tabIndex >= 0 && tabIndex < (item?.items?.length || 0)) {
        setActiveTabIndex(tabIndex)
      }
    },
  }))

  const makeLabel = (it: QuotationItemDTO, idx: number) => {
    const text = it.clientMaterialName || `明细${idx + 1}`
    return (
      <Tooltip title={text} getTooltipContainer={() => document.body}>
        <div
          style={{
            maxWidth: '120px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {text}
        </div>
      </Tooltip>
    )
  }

  const makeKey = (it: QuotationItemDTO, idx: number) => it?.id || `${idx}`

  // Tab切换处理
  const handleTabChange = (activeKey: string) => {
    const index =
      item?.items?.findIndex(
        (_: any, idx: number) => makeKey(item.items[idx], idx) === activeKey,
      ) ?? 0
    if (index !== -1) {
      setActiveTabIndex(index)
    }
  }

  // 分页切换处理
  const handlePageChange = (page: number) => {
    const targetIndex = page - 1 // 分页从1开始，数组索引从0开始
    setActiveTabIndex(targetIndex)
  }

  return (
    <div>
      <Tabs
        activeKey={makeKey(item?.items?.[activeTabIndex], activeTabIndex)}
        onChange={handleTabChange}
        items={
          item?.items?.map((it: QuotationItemDTO, idx: number) => ({
            label: makeLabel(it, idx),
            key: makeKey(it, idx),
            children: <TabItem item={it} bjdItem={item} index={idx} />,
            forceRender: true,
          })) || []
        }
        destroyInactiveTabPane={false}
      />
      <Row justify={'end'} className="mt-[20px]">
        <Pagination
          showQuickJumper
          pageSize={1}
          total={item?.items?.length}
          current={activeTabIndex + 1} // 分页从1开始，数组索引从0开始
          onChange={handlePageChange}
        />
      </Row>
    </div>
  )
})

XJForm.displayName = 'XJForm'

export default XJForm
